import { useEffect } from "react";
import { Radio, RECEIVE_RADIO, SEND_RADIO } from ".";
import { subscribeToolkitReduxDispatches } from "src/state/toolkitReduxStore";
import { toolkitRadioActions } from "./toolkitRadioStore";

export function useToolkitRadioRuntime() {
  useEffect(() => {
    const unsubscribe = subscribeToolkitReduxDispatches((action) => {
      if (action.type !== SEND_RADIO && action.type !== RECEIVE_RADIO) {
        return;
      }

      toolkitRadioActions.mergeRadio((action.payload ?? {}) as Partial<Radio>);
    });

    return () => {
      unsubscribe();
    };
  }, []);
}
